import PropTypes from 'prop-types';
import React from 'react';
import styles from './Breadcrumbs.styles.js';

const Breadcrumbs = ({
  crumbs,
  ...rest
}) => (
  <Container {...rest}>
    {
      buildBreadcrumbTrail(crumbs)
    }
  </Container>
);

const Container = ({
  children,
  ...rest
}) => (
  <div
    {...rest}
    style={styles.container}
  >
    {children}
  </div>
);

const Divider = () => (
  <div
    style={styles.divider}
  >
    >
  </div>
);

const Crumb = ({
  text,
  href,
  onClick
}) => (
  <a
    href={href}
    style={{
      cursor: onClick ? 'pointer' : 'initial',
      ...styles.crumb
    }}
    onClick={onClick}
  >
    {text}
  </a>
);

const CurrentLocation = ({
  text,
  isFirstEntry
}) => {
  let elementStyle = isFirstEntry
    ? { ...styles.currentLocation, fontWeight: 500 }
    : { ...styles.currentLocation, fontWeight: 400 };
  return (
    <div
      style={elementStyle}
    >
      {text}
    </div>
  );
};

function buildBreadcrumbTrail(crumbs) {
  let result = [];

  for (let i = 0; i < crumbs.length; i++) {
    let crumb = crumbs[i];
    if (i < (crumbs.length - 1)) {
      result.push(
        crumb.href || crumb.onClick
          ? <Crumb {...crumb} key={`crumb-${i}`} />
          : <CurrentLocation
            {...crumb}
            isFirstEntry={i === 0}
            key={`crumb-${i}`}
          />
      );
      result.push(
        <Divider
          key={`divider-${i}`}
        />
      );
    } else {
      result.push(
        <CurrentLocation
          {...crumb}
          key={`crumb-${i}`}
        />
      );
    }
  }

  return result;
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
  })),
};

export default Breadcrumbs;

export {
  Container,
  Crumb,
  CurrentLocation,
  Divider,
};
